import React , { useState }from "react";
import NoteContext from "./noteContext";
const BASE_URL = "https://inotebookbackend-jz73.onrender.com";

// It will hold all the states related to notes.
const NoteState = (props)=>{
    const host = BASE_URL;
    const notesInitial = [];
      // notes is an array
      const [notes, setNotes] = useState(notesInitial);

      // Get all Notes
      const getNotes = async(notetype)=>{
        //API call : Fetching all Notes
        var url;
        console.log("URL "+BASE_URL);
        if(notetype==="global") url = `${host}/api/notes/fetchglobalnotes`;
        else url = `${host}/api/notes/fetchallnotes`;
        // console.log(localStorage.getItem("token"));
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'auth-token': localStorage.getItem("token") // auth token
          }
        });
        const json = await response.json();
        setNotes(json); // Updating notes array
        // console.log(json);
      }
      // Add a note
      const addNote = async(title, description, tag)=>{
        //API call : To add note
        const url = `${host}/api/notes/addnote`;
        console.log("Add Note "+title, description, tag);
        const response = await fetch(url, {
          method: 'POST', // Using post method
          headers: {
            'Content-Type': 'application/json',
            'auth-token': localStorage.getItem("token")
          },
          body: JSON.stringify({title, description, tag}) // Sending data in body
        });
        const note  = await response.json();
        setNotes(notes.concat(note));// adding note in notes array
        
        getNotes();
      }

      // Delete a note
      const deleteNote = async(id)=>{
       // API call : to delete the note
       const url = `${host}/api/notes/deletenote/${id}`;
        const response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'auth-token': localStorage.getItem("token")
          }
        });
        const json = response.json();
        console.log(json);
        // Deleting note
        console.log("Deleting note with id"+id);
        // Only keeping those notes of different id
        const newNote = notes.filter((note)=>{return note._id!==id})
        setNotes(newNote);

        getNotes();
      }
      // Edit a note
      const editNote = async (note)=>{
        //API call : To update note
        let {_id, title, description, tag} = note;
        let id = _id;
        const url = `${host}/api/notes/updatenote/${_id}`;
        console.log('title update '+title +" "+JSON.stringify(note));
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'auth-token': localStorage.getItem("token")
          },
          body: JSON.stringify({id:_id, title:title, description:description, tag:tag}) // Sending data to be updated
        });
        const json =  await response.json();
        console.log(json);

        let newNotes = JSON.parse(JSON.stringify(notes)) // Creating Deep copy of notes
        //Logic to edit in client
        for (let index = 0; index < newNotes.length; index++) {
          const element = newNotes[index];
          if(element._id === id){
            newNotes[index].title = title;
            newNotes[index].description = description;
            newNotes[index].tag = tag;
            break;
          }
        }
        setNotes(newNotes);

        getNotes();
      }
    return(
        // Whichever things we want to provide , put it inside value., 
        <NoteContext.Provider value = {{notes, addNote, deleteNote, editNote, getNotes}}>
             {props.children} {/*Wrapping all childrens inside context*/}
        </NoteContext.Provider>
    )
}
export default NoteState;